export const common = {
    defaultLanguage: 'pl-PL',
    supportedLanguages: ['pl-PL', 'en-US', 'de-DE']
  };
